import styled from 'styled-components';
import { IonAccordion } from '@ionic/react';

export const Root = styled(IonAccordion)``;
